export interface WorkflowSectionDto {
    id: string;
    name: string;
}
